export const PACKAGE_VERSION = "23.6.0"
